import { ProductsCollection } from './ProductsCollection'
export default ProductsCollection
